import { Dayjs } from "dayjs";
import { CouponCode } from "./CouponCode";
import { FormResponse } from "./FormResponse";
import { Unit } from "./Unit";
import { CheckInRule } from "./UserPreferences";

export interface Guest {
    guest: any;
    id: ID;
    name: string;
    guestStatus: GuestStatus;
    checkInCount?: number;
    checkIns?: CheckIn[];
    ticketCode: string;
    unit: Unit;
    email: string;
    formResponse?: FormResponse;
    ticketPrintStatus?: TicketPrintStatus;
    primary: boolean;
    traveler?: { id: ID, email?: string };
    template?: { id: ID };
    membershipCode?: { id: ID } | CouponCode;
    sequence?: number;
    waiver?: { id: ID } | null;
    participant?: ID;
    _linkWaiver?: boolean;
    organizer?: boolean;
}

export interface FormGuest extends Guest {
    incrementCheckInCount?: GuestCheckInAction;
}

interface TicketPrintStatus {
    printed?: boolean;
    checkInRuleResponses?: CheckInRuleResponse[];
    reason?: string;
    printCount?: number;
}

export interface CheckInRuleResponse extends CheckInRule {
    status: CheckInRuleResponseStatus;
}

export enum GuestStatus {
    PENDING = "pending",
    ARRIVED = "arrived",
    NO_SHOW = "noshow",
    RETURNED = "returned",
}

export const GuestStatusCopy: Record<GuestStatus, string> = {
    [GuestStatus.PENDING]: "Pending",
    [GuestStatus.ARRIVED]: "Arrived",
    [GuestStatus.NO_SHOW]: "No Show",
    [GuestStatus.RETURNED]: "Returned",
};

export enum CheckInRuleResponseStatus {
    PASS = "pass",
    FAIL = "fail",
}

export enum GuestNameSource {
    DEFAULT = "default",
    SELLER = "seller",
    WAIVER = "waiver",
}

export enum GuestCheckInAction {
    CHECK_IN = 1,
    UNDO_CHECK_IN = -1,
}

export enum CheckInVerificationStatus {
    ID_VERIFIED = "id_verified",
    NOT_VERIFIED = "not_verified",
}

export interface CheckIn {
    verificationStatus?: CheckInVerificationStatus;
    userAgent?: string;
    createdAt: Dayjs;
    createdBy?: { id: ID };
    deletedAt?: Dayjs;
    deletedBy?: { id: ID };
}
